import React from "react";
import CustomAlert from "../base/CustomAlert";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import i18n from "utils/I18n";
import { ACTION_BUTTON_STATUS } from "./CheckInSection";
import { ACTION_BUTTON_TO_COUPON_PAGE } from '../../utils/Config'
import { createAction } from "utils";

const mapStateToProps = (state, ownProps) => {
  return {
    actionButtonStatus: state.campaignDetail.actionButtonStatus,
  }
};

// Deprecated
const StampCampaignCouponAlert = ({
  show,
  onHide,
  campaignID,
  rewardID,
  couponName,
  quantity,
  actionButtonStatus,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const isLoading = actionButtonStatus === ACTION_BUTTON_STATUS.LOADING;
  const isAcquired = actionButtonStatus === ACTION_BUTTON_STATUS.MYCOUPON;

  const closeAlert = () => {
    onHide();
  };

  const leftBtnAction = () => {
    closeAlert();
  };

  const rightBtnAction = () => {
    if (isAcquired) {
      dispatch(createAction('myCoupon/changeTab')({ index: 0 }));
      history.push('/user/myCoupon');
      closeAlert()
    } else {
      dispatch({
        type: 'campaignDetail/customerAcquireStampReward',
        payload: {
          campaignID,
          rewardID,
          stampRewardCouponQuantity: quantity,
        }
      });
    }
  }
  const getRightButton = () => {
    if (!isAcquired) {
      return i18n.t('campaign_confirm')
    }
    if(!ACTION_BUTTON_TO_COUPON_PAGE) {
      return ''
    }
    return i18n.t('profile_my_coupons')
  }
  return (
    <CustomAlert
      backdrop="static"
      show={show}
      onHide={closeAlert}
      title={
        isAcquired
          ? i18n.t('campaignDetail:successfullyAcquired')
          : i18n.t('campaignDetail:confirmToAcquireCoupon', { count: quantity })
      }
      message={
        isAcquired
          ? ''
          : couponName
      }
      leftbtn={
        isAcquired
          ? i18n.t('campaign_ok')
          : i18n.t('message_cancel')
      }
      leftAction={leftBtnAction}
      rightbtn={getRightButton()}
      rightAction={rightBtnAction}
      isLoading={isLoading}
    ></CustomAlert>
  )
}

export default connect(mapStateToProps)(StampCampaignCouponAlert);